module.exports = __webpack_public_path__ + "media/images/Preview_Image.001-5e4ad2fcf5d576711aab5118b0a175dd.png";